import Optional from '@acri-tools/react-tools/components/Optional/Optional';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import { Component } from 'react';
import { check_contact } from '../../utils/it_contacts';

import './CreateContact.css';
import ContactForm from '../ContactForm/ContactForm';

interface Props {
    onCreate?: Function
}
interface State {
    creating: boolean

    name: string
    email: string
    type: string
}

const default_values = {
    name: '',
    email: '',
    type: 'RECIPIENT'
}


export default class CreateRequest extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            creating: false,
            ...default_values,
        }
    }

    render() {
        return (
            <div className="create-request">
                <ContactForm
                    contact={this.state}
                    onChange={(updates: any) => {
                        this.setState(updates);
                    }}
                />

                <br />
                <br />
                <div className="centered">
                    <div
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.creating
                        })}
                        onClick={this.create}
                    >
                        {
                            this.state.creating ?
                                <Spinner height={15} white /> :
                                <><i className="fas fa-plus" /> ADD CONTACT</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    create = async () => {
        let payload: any = { ...this.state };
        delete payload.creating;

        try {
            check_contact(payload);
        }
        catch (e: any) {
            return create_toast({ type: e.type, message: e.message })
        }

        this.setState({ creating: true })
        try {
            let res = await request(`${API_URL}/api/v1/contacts`, {
                method: 'post',
                data: payload
            })

            this.props.onCreate?.();
            this.setState({
                ...default_values,
            });

            create_toast({ type: 'success', message: `Successfully created contact ${res.data.name}` })

        }
        catch (e: any) {
            axiosErrorHandler(e, {
                functionName: 'create'
            })
            toast_request_error(e);
        }
        finally {
            this.setState({ creating: false })
        }
    }
};